<script setup lang="ts">
  import { IconAiGradient } from '../icons'
  import { TooltipHint } from '../tooltips'
  import { useFormFieldProvider } from './gat-form-field.vue'
  const { hasAiValue, aiHint } = useFormFieldProvider()
</script>

<template>
  <tooltip-hint v-if="hasAiValue && aiHint">
    <div class="size-fit">
      <icon-ai-gradient class="size-4" />
    </div>
    <template #content>{{ aiHint }}</template>
  </tooltip-hint>
  <icon-ai-gradient v-else-if="hasAiValue" class="size-4" />
</template>
